import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgWifiSignal = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M9.33325 18.0001C9.33325 18.7073 9.6142 19.3856 10.1143 19.8857C10.6144 20.3858 11.2927 20.6667 11.9999 20.6667C12.7072 20.6667 13.3854 20.3858 13.8855 19.8857C14.3856 19.3856 14.6666 18.7073 14.6666 18.0001C14.6666 17.2928 14.3856 16.6145 13.8855 16.1144C13.3854 15.6144 12.7072 15.3334 11.9999 15.3334C11.2927 15.3334 10.6144 15.6144 10.1143 16.1144C9.6142 16.6145 9.33325 17.2928 9.33325 18.0001Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.711 13.2864C15.4608 12.0363 13.7652 11.3341 11.9972 11.3341C10.2292 11.3341 8.53367 12.0363 7.28345 13.2864"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.5422 10.458C17.5418 8.45776 14.8288 7.33405 12 7.33405C9.17113 7.33405 6.45813 8.45776 4.45776 10.458"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22 7.27215C19.285 4.74159 15.7115 3.33447 12 3.33447C8.28851 3.33447 4.71504 4.74159 2 7.27215"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgWifiSignal.displayName = 'SvgWifiSignal';
export default SvgWifiSignal;
